import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Gamepad2, Sparkles, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-brand-offwhite px-4 pt-20" data-id="element-73">
      {/* Decorative Background Elements */}
      <motion.div animate={{
      rotate: 360
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute top-20 right-[10%] w-32 h-32 text-brand-yellow opacity-80" data-id="element-74">
        <Star size={128} fill="currentColor" data-id="element-75" />
      </motion.div>

      <motion.div animate={{
      y: [-20, 20, -20]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute bottom-20 left-[5%] w-24 h-24 bg-brand-purple rounded-full border-4 border-brand-navy opacity-60" data-id="element-76" />

      <motion.div animate={{
      rotate: -10,
      scale: [1, 1.1, 1]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-40 left-[15%] w-16 h-16 bg-brand-lime rotate-12 border-4 border-brand-navy" data-id="element-77" />

      <div className="container mx-auto max-w-6xl relative z-10 grid md:grid-cols-2 gap-12 items-center" data-id="element-78">
        <div className="space-y-8 text-center md:text-left" data-id="element-79">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-80">
            <span className="inline-block px-4 py-1 bg-brand-lime border-2 border-brand-navy font-bold text-brand-navy mb-4 rotate-[-2deg]" data-id="element-81">
              Limassol's Quirkiest Curator
            </span>
            <h1 className="text-6xl md:text-8xl font-display font-black text-brand-navy leading-[0.9]" data-id="element-82">
              Where <span className="text-brand-pink italic" data-id="element-83">Weird</span>{' '}
              Becomes <span className="text-brand-purple" data-id="element-84">Wonderful</span>
            </h1>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl md:text-2xl font-body text-brand-navy/80 max-w-lg mx-auto md:mx-0" data-id="element-85">
            Jeuxtraordinaire curates the uncurated. We hunt down the games
            algorithms ignore and serve them on a silver platter.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-86">
            <Button size="lg" variant="primary" data-id="element-87">
              Discover the Extraordinary
            </Button>
            <Button size="lg" variant="outline" data-id="element-88">
              Our Manifesto
            </Button>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.8,
        rotate: 5
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="relative hidden md:block" data-id="element-89">
          <div className="relative z-10 bg-brand-navy p-8 border-4 border-brand-navy transform rotate-3 shadow-quirky-lg" data-id="element-90">
            <div className="bg-brand-offwhite border-2 border-brand-navy p-6 flex flex-col items-center justify-center min-h-[400px]" data-id="element-91">
              <Gamepad2 size={80} className="text-brand-pink mb-6" data-id="element-92" />
              <h3 className="font-display text-3xl text-center mb-2" data-id="element-93">
                Curator's Choice
              </h3>
              <p className="font-body text-center text-gray-600" data-id="element-94">
                "If it doesn't make you question reality, we don't play it."
              </p>
              <div className="mt-8 flex gap-2" data-id="element-95">
                <Sparkles className="text-brand-yellow animate-pulse" data-id="element-96" />
                <Sparkles className="text-brand-lime animate-pulse delay-100" data-id="element-97" />
                <Sparkles className="text-brand-purple animate-pulse delay-200" data-id="element-98" />
              </div>
            </div>
          </div>
          {/* Background offset shape */}
          <div className="absolute inset-0 bg-brand-pink border-4 border-brand-navy transform -rotate-2 translate-x-4 translate-y-4 -z-10" data-id="element-99"></div>
        </motion.div>
      </div>
    </section>;
}